__turbopack_context__.v({
  "AnchorDisabled": "DownloadButton-module-scss-module__LxQ9qa__AnchorDisabled",
  "Button": "DownloadButton-module-scss-module__LxQ9qa__Button",
  "ButtonDark": "DownloadButton-module-scss-module__LxQ9qa__ButtonDark",
  "ButtonIcon": "DownloadButton-module-scss-module__LxQ9qa__ButtonIcon",
  "ButtonLight": "DownloadButton-module-scss-module__LxQ9qa__ButtonLight",
  "ButtonNone": "DownloadButton-module-scss-module__LxQ9qa__ButtonNone",
  "ButtonPreIcon": "DownloadButton-module-scss-module__LxQ9qa__ButtonPreIcon",
  "ButtonText": "DownloadButton-module-scss-module__LxQ9qa__ButtonText",
  "ButtonTextual": "DownloadButton-module-scss-module__LxQ9qa__ButtonTextual",
  "ButtonTextualWhite": "DownloadButton-module-scss-module__LxQ9qa__ButtonTextualWhite",
});
